
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from 'react-hook-form';

interface MedicationsFieldProps {
  form: UseFormReturn<any>;
}

const MedicationsField: React.FC<MedicationsFieldProps> = ({ form }) => {
  const watchTakingMedications = form.watch("takingMedications");

  return (
    <div className="space-y-4 border-b pb-4">
      <FormField
        control={form.control}
        name="takingMedications"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3">
            <div className="space-y-0.5">
              <FormLabel>Are you currently taking any medications?</FormLabel>
              <FormDescription>
                Including prescription medications, supplements, or hormones
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {watchTakingMedications && (
        <FormField
          control={form.control}
          name="medicationsDetails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Please list the medications you are taking</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Please list medications, supplements, etc."
                  className="resize-none"
                  {...field}
                  value={field.value || ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
};

export default MedicationsField;
